import { PostDamagedAdjusterDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedAdjusterDocumentImages/postDamagedAdjusterDocumentImagesQuery.type';
import { postDamagedAdjusterDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedAdjusterDocumentImages/postDamagedAdjusterDocumentImagesQueryFunction';

export const postDamagedAdjusterDocumentImagesQueryOptions = () => {
  return {
    mutationKey: ['postDamagedAdjusterDocumentImages'],
    mutationFn: (params: PostDamagedAdjusterDocumentImagesQueryParamsType) =>
      postDamagedAdjusterDocumentImagesFunction(params),
  };
};
